"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PageTitle = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = require("prop-types");
var _constants = require("../../../constants");
var _JoinComponent = require("../JoinComponent.styled");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * PageTitle component renders the title for the current page.
 * @param {string} page - Current page identifier
 * @returns {JSX.Element} The title component for the page
 */
var PageTitle = exports.PageTitle = /*#__PURE__*/(0, _react.memo)(function (_ref) {
  var _TitlePageMap;
  var page = _ref.page;
  var TitlePageMap = (_TitlePageMap = {}, (0, _defineProperty2["default"])(_TitlePageMap, _constants.JOIN_PAGE.SETTINGS, 'Settings'), (0, _defineProperty2["default"])(_TitlePageMap, _constants.JOIN_PAGE.SYSTEM_CHECK, 'System Check'), _TitlePageMap);
  return /*#__PURE__*/_react["default"].createElement(_JoinComponent.StyledCardTitle, {
    tag: "h4"
  }, TitlePageMap[page]);
});
PageTitle.propTypes = {
  page: _propTypes.string.isRequired
};